/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ScreenshotQueueResponse { 
    id?: string;
    pageUrl?: string;
    contractType?: ScreenshotQueueResponse.ContractTypeEnum;
    contractId?: string;
    createdAt?: Date;
}
export namespace ScreenshotQueueResponse {
    export type ContractTypeEnum = 'CONTRACT_NOTICE' | 'CONTRACT_ANNOUNCEMENT';
    export const ContractTypeEnum = {
        NOTICE: 'CONTRACT_NOTICE' as ContractTypeEnum,
        ANNOUNCEMENT: 'CONTRACT_ANNOUNCEMENT' as ContractTypeEnum
    };
}